import React from 'react';

import { useLoadNativeAd } from '@client/hooks';
import {
  LayoutType,
  NativeAdObj,
  PlacementId,
  Vertical
} from '@schibsted-nmp/advertising-shared';
import { BapNativeAdvertisement } from '@schibsted-nmp/search-frontend-components/react/advertising';
import { i18n } from '@lingui/core';

import { getDescription } from './native.helper';
import Comment from './parts/Comment';
import { Status } from '../../../types';
import NativeLogo from './parts/NativeLogo';
import NativeCogwheel from './parts/NativeCogwheel';

export type Props = {
  adObj: NativeAdObj;
  targetId: string;
  placementId: PlacementId;
  className?: string;
  vertical?: Vertical;
  layoutType?: LayoutType;
  status: Status;
};

export default function NativeAdComponent(props: Props) {
  const { targetId, adObj, vertical, layoutType } = props;
  const { native } = adObj;
  const list = layoutType === 'list';
  useLoadNativeAd(adObj, targetId, props.status);

  const ad = {
    heading: native.title,
    organisation_name: getDescription(native),
    image: { ...native.image, path: native.image.url }
  };

  const adLabel = i18n.t({
    id: 'native.advertisement',
    message: 'advertisement'
  });

  const layout = (layoutType ?? 'grid') as any;
  return (
    <div id={targetId}>
      <BapNativeAdvertisement
        ad={ad}
        layout={layout}
        url={native.clickUrl}
        label={({ classes }) => (
          <span className={`${classes.badge} ${classes.neutral}`}>
            {adLabel}
          </span>
        )}
        sponsorName={() => <span>{native.sponsoredBy}</span>}
        contentBottom={() => (
          <>
            <NativeLogo native={native} isWide={list} className="col-span-2" />
            <Comment
              placement={`GeneralResultAd - ${vertical}`}
              adObj={adObj}
            />
          </>
        )}
      />
      <NativeCogwheel adObj={adObj} />
    </div>
  );
}
